import { render, staticRenderFns } from "./ProgressSpinner.vue?vue&type=template&id=73fe31e2&scoped=true&lang=pug&"
var script = {}
import style0 from "./ProgressSpinner.vue?vue&type=style&index=0&id=73fe31e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe31e2",
  null
  
)

export default component.exports